import React from "react";
import { useSelector } from "react-redux";

import { allTALDAppetiteCode } from "shared/helper";
import SearchResultsErrorWrapper from "components/SearchPage/SearchResultsErrorWrapper/SearchResultsErrorWrapper";
import { options } from "shared/globalData";
import SpectrumMobileResultsTable from "./Mobile/SpectrumMobileResultsTable";
import SpectrumDesktopResultsTable from "./Desktop/SpectrumDesktopResultsTable";

export const SpectrumSearchResults = ({ activeTabID }) => {
  const { data } = useSelector((state) => state.searchResultsReducer);
  /**
   * Get the appropriate icon and color/styling for the results table lob appetite columns
   * @param {string} appetiteCd Appetite code from the response data for the specific lob
   * @return {string} huk icon in html format that is needed to set the icon and color for JSON object
   */
  const getHukTableIcon = (appetiteCd) => {
    return `<huk-icon icon='${allTALDAppetiteCode(
      appetiteCd,
      "icon"
    )}' style='color: ${allTALDAppetiteCode(appetiteCd, "color")}'>`;
  };  
  
  const isoglOptions = options.find(opt => opt.checked);

  const selectedOption = {
    name: isoglOptions?.name,
    searchType: isoglOptions?.searchType,
  };

  function getContentISOGL(selectedOption, item) {
  let contentISOGL = "--";

  const listOfSearchTypes = [   
    "Description", 
    "NAICS code",
    "SIC code",  
    "Workers' Comp code",
    "ISO GL code",
    "Spectrum code"
  ];

  if (listOfSearchTypes.includes(selectedOption?.name)) {
    contentISOGL = (item.businessClassCdTypeName === "ISO_CGL")
      ? item.classCode ?? "--"
      : item.associatedGLCdList ?? "--";
  } 
  else {
    contentISOGL = "--";
  }

  return contentISOGL;
}  

  const searchResultsJSON = {
    tableCss: {
      compact: true,
      stickyhdr: true,
    },
    tableHeadings: [
      {
        colId: "1",
        heading: "BOP Code",
        sortable: "true",
        dataField: "accept",
      },
      {
        colId: "2",
        heading: "ISO GL",
        sortable: "true",
        width: "5.5rem",
      },
      {
        colId: "3",
        heading: "SIC",
        sortable: "true",
      },
      {
        colId: "4",
        heading: "NAICS",
        sortable: "true",
        dataField: "policy",
        dataType: "number",
      },
      {
        colId: "5",
        heading: "Description",
        sortable: "true",
        dataField: "owner",
        width: "30rem",
      },
      {
        colId: "6",
        heading: "BOP",
      },
      {
        colId: "7",
        heading: "WC",
      },
      {
        colId: "8",
        heading: "Auto",
      },
      {
        colId: "9",
        heading: "Mgt Liab",
      },
      {
        colId: "10",
        heading: "Cyber",
      },
      {
        colId: "11",
        heading: "Prof liab",
      },
      {
        colId: "12",
        heading: "E&S",
      },
      {
        colId: "13",
        heading: "",
        sortable: "false",
        dataField: "submit",
        hukComponent: "button",
      },
    ],
    tableRows: data.map((item) => {
      // E&S column logic
      const espl = item.esplTaldAppttCode;
      const espt = item.esptaldAppttCode;
      const eslt = item.esltaldAppttCode;
      let esColContent = "--";

      if ([espl, espt, eslt].includes("A")) {
        esColContent = getHukTableIcon("A");
        console.log("esColContent", esColContent);
      } else if (
        [espl, espt, eslt].some((item) => item === "S") &&
        ![espl, espt, eslt].includes("A")
      ) {
        esColContent = getHukTableIcon("S");
      } else if (
        [espl, espt, eslt].every((item) => item === "P")
      ) {
        esColContent = getHukTableIcon("P");
      }

      return {
        tableData: [
          {
            colId: "1",
            content:
              item.businessClassCdTypeName === "SPCTRM" ? item.classCode : "--",
          },
          {
            colId: "2",
            content: getContentISOGL(selectedOption,item),
          },
          {
            colId: "3",
            content: item.siccode,
          },
          {
            colId: "4",
            content: item.naicscode,
          },
          {
            colId: "5",
            format: "html",
            content: `<div style='font-weight: 500'>${item.descriptorText}</div>`,
          },
          {
            colId: "6",
            format: "html",
            content:
              item.specTALDAppetiteCd === "--" ||
              item.specTALDAppetiteCd === null
                ? "--"
                : getHukTableIcon(item.specTALDAppetiteCd),
          },
          {
            colId: "7",
            format: "html",
            content:
              item.wctaldappetiteCd === "--" || item.wctaldappetiteCd === null
                ? "--"
                : getHukTableIcon(item.wctaldappetiteCd),
          },
          {
            colId: "8",
            format: "html",
            content:
              item.cataldappetiteCd === "--" || item.cataldappetiteCd === null
                ? "--"
                : getHukTableIcon(item.cataldappetiteCd),
          },
          {
            colId: "9",
            format: "html",
            content:
              item.mltaldappetiteCode === "--" ||
              item.mltaldappetiteCode === null
                ? "--"
                : getHukTableIcon(item.mltaldappetiteCode),
          },
          {
            colId: "10",
            format: "html",
            content:
              item.cyberTalnCd === "--" || item.cyberTalnCd === null
                ? "--"
                : getHukTableIcon(item.cyberTalnCd),
          },
          {
            colId: "11",
            format: "html",
            content:
              item.scpltaldaappetiteCode === "--" ||
              item.scpltaldaappetiteCode === null
                ? "--"
                : getHukTableIcon(item.scpltaldaappetiteCode),
          },
          {
            colId: "12",
            format: "html",
            content: esColContent,
          },
          {
            colId: "13",
            value: "Details",
            hukclass: "btn-secondary btn-xs",
            align: "right",
            buttonIcon: "icon icon-caret-right",
            onclick: "showDetailsModal",
          },
        ],
      };
    }),
  };
  // show appropriate table based on screen size
  return (
    <SearchResultsErrorWrapper activeTabID={activeTabID}>
      <div>
        {/* show desktop table when screen is >992px */}
        <div className="d-none d-lg-block">
          <SpectrumDesktopResultsTable searchResultsJSON={searchResultsJSON} />
        </div>
        {/* show mobile table when screen is <992px */}
        <div className="d-block d-lg-none">
          <SpectrumMobileResultsTable searchResultsJSON={searchResultsJSON} />
        </div>
      </div>
    </SearchResultsErrorWrapper>
  );
};

export default SpectrumSearchResults;
